import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import {
  TextField,
  Button,
  InputLabel,
  FormControl,
  FormHelperText,
  FormGroup,
  Select as MuiSelect,
  Checkbox
} from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { SelectMultiField } from '../../common';
import { isMobile } from 'react-device-detect';
import { setData as setDataAction } from '../../../redux/dataSlice';
import { baseApiUrl, getTenantConfig } from '../../../config';
import customClientConfig from '../../../customClientConfig';

const { tenant } = getTenantConfig();
const tenantHasIsi = Boolean(customClientConfig[tenant]?.hasIsi);
const isMaci = tenant === 'vericelmaci';

// TODO: specialty and degree should be a tagcloud. If from npi registry and no
// specialty or degree match, then use 'Other' and add to the other field.

const VERICEL_REP_ROLE = 'VERICEL_REP';

const VericelRegFormComponent = (props) => {
  const { dropDownValues, isLicensed, npiInfo, meetingInfo, setData, regSource } = props;

  const [formValues, setFormValues] = React.useState({
    meeting_id: meetingInfo.id,
    reg_source: regSource,
    email_consent: true,
    sms_opt_in: false
  });
  const [formErrors, setFormErrors] = React.useState({});
  const [submitted, setSubmitted] = React.useState(false);
  const [submitError, setSubmitError] = React.useState(null);
  const [npiDataObj, setNpiDataObj] = React.useState({});
  const [attendanceType, setAttendanceType] = React.useState(null);
  // const [isFormUpdated, setIsFormUpdated] = React.useState(0);

  const isVericelRep = !isLicensed && formValues.role === VERICEL_REP_ROLE;

  React.useEffect(() => {
    const root = document.getElementById('root');
    if (root) root.scrollTop = 0;
  }, []);

  React.useEffect(() => {
    if (!submitted) return;
    const root = document.getElementById('root');
    const typ = document.getElementById('thank-you-page');
    if (root && typ) {
      root.scrollTop = root.scrollTop + typ.getBoundingClientRect().top - 200;
    }
  }, [submitted]);

  React.useEffect(() => {
    let newFormValues = { ...formValues };

    if (isLicensed && !_.isEmpty(npiInfo)) {
      let npiData = {};
      if (_.keys(npiInfo).includes('basic')) {
        // data coming from the npi registry
        const { basic, addresses, taxonomies } = npiInfo;

        console.log('data coming from nppes', npiInfo);
        npiData = {
          npi: npiInfo.number,
          firstname: basic.first_name,
          lastname: basic.last_name,
          minitial: basic.middle_name ? basic.middle_name[0] : '',
          address1: addresses[0].address_1 || '',
          address2: addresses[0].address_2 || '',
          city: addresses[0].city || '',
          state: addresses[0].state || '',
          zip: addresses[0].postal_code || '',
          ...computeTagCloudValues(
            _.compact(taxonomies.map((taxonomy) => taxonomy.desc)),
            dropDownValues.specialties,
            'specialty'
          ),
          ...computeTagCloudValues(_.compact([basic.credential]), dropDownValues.degrees, 'degree')
        };
      } else {
        // data coming from the hlx database
        console.log('data coming from the hlx/medpro database', npiInfo);
        npiData = {
          contactId: npiInfo.contactid,
          npi: npiInfo.npinumber,
          firstname: npiInfo.firstname,
          lastname: npiInfo.lastname,
          minitial: npiInfo.middleinitial,
          orgname: npiInfo.orgname,
          address1: npiInfo.orgaddress1,
          address2: npiInfo.orgaddress2,
          phone: npiInfo.phone,
          city: npiInfo.orgcity,
          state: npiInfo.orgstate,
          zip: npiInfo.orgpostalcode,
          email: npiInfo.email,
          ...computeTagCloudValues(
            _.compact(npiInfo.specialty.split(',').map((spclty) => spclty.trim())),
            dropDownValues.specialties,
            'specialty'
          ),
          ...computeTagCloudValues(
            _.compact(npiInfo.medicaldegree.split(',').map((dgr) => dgr.trim())),
            dropDownValues.degrees,
            'degree'
          )
        };
      }
      setNpiDataObj(npiData);

      newFormValues = { ...formValues, ...npiData };
      // console.log('updatedFormValues', updatedFormValues);
      // setFormValues(updatedFormValues);
      // setTimeout(() => setIsFormUpdated(isFormUpdated + 1), 1000);
    }
    if (meetingInfo.sms_opt_in_enabled) {
      newFormValues.sms_opt_in = true;
    }
    setFormValues(newFormValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // React.useEffect(() => {
  //   console.log('isFormUpdated', isFormUpdated);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isFormUpdated]);

  const computeTagCloudValues = (incomingValues, incomingdropDownValues, objectKey) => {
    console.log('incoming', objectKey, incomingValues);
    const tagArray = [];
    let otherElem = '';
    let otherTagFlag = false;
    if (incomingValues && incomingValues.length > 0) {
      const otherDropDownElem = _.find(
        incomingdropDownValues,
        (elem) => elem.name.toUpperCase() === 'OTHER'
      );

      incomingValues.forEach((elemName) => {
        if (elemName.toUpperCase() !== 'OTHER') {
          const dropdownElem = _.find(
            incomingdropDownValues,
            (elem) => elem.name.toUpperCase() === elemName.toUpperCase()
          );
          const valueName = dropdownElem && dropdownElem.name;
          if (valueName) {
            tagArray.push({ value: valueName, label: valueName });
          } else if (otherDropDownElem) {
            if (!otherTagFlag) {
              tagArray.push({
                value: otherDropDownElem.name,
                label: otherDropDownElem.name
              });
              otherTagFlag = true;
            }
            otherElem = otherElem.length ? (otherElem += `, ${elemName}`) : elemName;
          }
        }
      });
    }
    return { [objectKey]: tagArray, [`other_${objectKey}`]: otherElem };
  };

  const validateFields = () => {
    let requiredFields = ['firstname', 'lastname', 'email', 'email_consent', 'phone'];

    if (!isVericelRep) {
      requiredFields = requiredFields.concat(['address1', 'city', 'state', 'zip']);
    }

    if (isLicensed) {
      requiredFields = requiredFields.concat([
        'npi',
        'specialty',
        'degree',
        'orgname',
        'licensed_state'
      ]);
      (formValues.specialty || []).forEach((specialty) => {
        if (specialty.value.toUpperCase() === 'OTHER') {
          requiredFields.push('other_specialty');
        }
      });
      (formValues.degree || []).forEach((degree) => {
        if (degree.value.toUpperCase() === 'OTHER') {
          requiredFields.push('other_degree');
        }
      });
    } else {
      requiredFields.push('role');
      if (!isVericelRep) {
        requiredFields.push('orgname');
        if (formValues.role?.toUpperCase() === 'OTH') {
          requiredFields.push('other_role');
        }
      }
    }

    const errors = {};
    requiredFields.forEach((field) => {
      if (!formValues[field]) {
        errors[field] = true;
      }
    });

    if (formValues.npi) {
      const npiLength = formValues.npi.toString().length;
      if (isLicensed && npiLength !== 10) {
        errors.npi = true;
      }
    }

    if (formValues.email) {
      if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(formValues.email)) {
        errors.email = true;
      }
    }

    if (meetingInfo.is_virtual_hybrid && !attendanceType) {
      errors.attendanceType = true;
    }

    setFormErrors(errors);
    return _.isEmpty(errors);
  };

  const submitForm = async () => {
    const isValid = validateFields();
    console.log('isValid', isValid, formErrors);
    formValues.isLicensed = isLicensed;

    if (isValid) {
      console.log('formValues', formValues);
      const formPayload = { ...formValues };

      formPayload.specialty = _.map(formPayload.specialty || [], 'value').join(', ');
      if (formPayload.other_specialty) {
        formPayload.specialty = `${formPayload.specialty}, ${formPayload.other_specialty}`;
      }
      formPayload.degree = _.map(formPayload.degree || [], 'value').join(', ');
      if (formPayload.other_degree) {
        formPayload.degree = `${formPayload.degree}, ${formPayload.other_degree}`;
      }

      if (formPayload.role?.toUpperCase() === 'OTH') {
        formPayload.role = formPayload.other_role;
      }

      if (isVericelRep) {
        formPayload.attendeeType = 9;
        delete formPayload.role;
      }

      if (meetingInfo.is_virtual_hybrid) {
        formPayload.is_virtual_attendee = attendanceType === 'virtual' ? 1 : 0;
      }

      // // this is going to opposite of what the user selects because the api is expecting 0 for opt out
      // // but the checkbox text says opt in
      // formPayload.opt_out_sms = formPayload.opt_out_sms ? 0 : 1;

      const req = await fetch(`${baseApiUrl}/api/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ...formPayload, contactId: npiInfo.contactid })
      });
      if (req.status === 201) {
        setSubmitted(true);
      } else if (req.status === 403) {
        setSubmitError('This meeting is at capacity.');
      } else if (req.status === 401) {
        setSubmitError('You are already registered for this meeting.');
      } else {
        setSubmitError('Something went wrong with your submission.');
      }
    }
  };

  const updateFormField = (field) => {
    return (event) => {
      const { value, checked } = event.target;
      if (_.includes(['email_consent', 'sms_opt_in'], field)) {
        return setFormValues((prev) => ({ ...prev, [field]: checked }));
      }
      setFormValues((prev) => {
        let next = { ...prev, [field]: value };
        if (field === 'role') {
          if (value === VERICEL_REP_ROLE) {
            next = {
              ...next,
              orgname: 'Vericel',
              address1: '25 Blue Sky Drive',
              address2: '',
              city: 'Burlington',
              state: 'MA',
              zip: '01804'
            };
          } else if (prev.role === VERICEL_REP_ROLE) {
            next = {
              ...next,
              orgname: '',
              address1: '',
              address2: '',
              city: '',
              state: '',
              zip: ''
            };
          }
        }
        return next;
      });
    };
  };

  const onVirtualHybridChange = (label) => {
    return (e) => {
      if (e.target.checked) {
        // console.log('lavel here', label);
        setAttendanceType(label);
      }
    };
  };

  const updateSelectMultiple = (field) => {
    return (values) => {
      setFormValues({ ...formValues, [field]: values });
    };
  };

  const renderNpiFields = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex' }}>
          <TextField
            disabled={Boolean(npiInfo && /^\d{10}$/.test(npiDataObj.npi))}
            fullWidth
            style={{ margin: 10 }}
            value={formValues.npi || ''}
            onChange={updateFormField('npi')}
            label={'*NPI'}
            error={formErrors.npi}
            helperText={formErrors.npi && 'NPI must be 10 digits'}
            margin={'dense'}
            variant={'outlined'}
            type="number"
          />
        </div>
        <div style={{ width: '50%', display: 'flex' }} className="mobile-portrait-width-unset">
          <FormControl fullWidth style={{ margin: 10 }} error={Boolean(formErrors.licensed_state)}>
            <InputLabel
              variant="outlined"
              margin="dense"
              htmlFor="licensed_state"
              error={Boolean(formErrors.licensed_state)}
            >
              *License State
            </InputLabel>
            <MuiSelect
              native
              variant={'outlined'}
              value={formValues.licensed_state || ''}
              onChange={updateFormField('licensed_state')}
              margin={'dense'}
              label="*License State"
              error={Boolean(formErrors.licensed_state)}
              inputProps={{
                name: 'licensed_state',
                id: 'licensed_state',
                maxLength: 2
              }}
            >
              <option aria-label="None" key="none" value="" />
              {_.map(dropDownValues.states, (state) => {
                return (
                  <option key={state.abrv} value={state.abrv}>
                    {state.name}
                  </option>
                );
              })}
            </MuiSelect>
          </FormControl>
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.license_number || ''}
            onChange={updateFormField('license_number')}
            label={'License #'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 30 }}
          />
        </div>
      </div>
    );
  };

  if (submitted) {
    return (
      <div
        id="thank-you-page"
        style={{
          paddingBottom: isMobile && tenantHasIsi ? 100 : 0,
          textAlign: isMobile && 'center',
          minHeight: tenantHasIsi ? 300 : undefined
        }}
      >
        <h2>Thank you for submitting your registration!</h2>
      </div>
    );
  }

  // console.log('formValues', formValues);

  return (
    <div
      style={{
        paddingBottom: isMobile && tenantHasIsi ? 100 : 0,
        minHeight: tenantHasIsi ? 500 : undefined
      }}
    >
      <Button
        variant="text"
        onClick={() =>
          setData(isLicensed ? { npiInfo: null } : { npiInfo: null, isLicensed: null })
        }
        style={{
          textTransform: 'none',
          color: '#000',
          fontWeight: 600,
          paddingLeft: 10,
          marginBottom: 4
        }}
      >
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          <ChevronLeftIcon style={{ fontSize: 24, marginLeft: -6 }} />
          Back
        </span>
      </Button>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            disabled={Boolean(npiInfo && npiDataObj.firstname)}
            style={{ margin: 10 }}
            value={formValues.firstname || ''}
            onChange={updateFormField('firstname')}
            label={'*First Name'}
            margin={'dense'}
            variant={'outlined'}
            error={formErrors.firstname}
            inputProps={{ maxLength: 35 }}
          />
          <TextField
            fullWidth
            disabled={Boolean(npiInfo && npiDataObj.minitial)}
            style={{ margin: 10 }}
            value={formValues.minitial || ''}
            onChange={updateFormField('minitial')}
            label={'Middle Name Initial'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 1 }}
          />
        </div>
        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            disabled={Boolean(npiInfo && npiDataObj.lastname)}
            style={{ margin: 10 }}
            value={formValues.lastname || ''}
            onChange={updateFormField('lastname')}
            label={'*Last Name'}
            margin={'dense'}
            variant={'outlined'}
            error={formErrors.lastname}
            inputProps={{ maxLength: 35 }}
          />
          <TextField
            fullWidth
            disabled={Boolean(npiInfo && npiDataObj.suffix)}
            style={{ margin: 10 }}
            value={formValues.suffix || ''}
            onChange={updateFormField('suffix')}
            label={'Suffix'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 75 }}
          />
        </div>
        {!isLicensed && (
          <div
            style={{ display: formValues.role?.toUpperCase() === 'OTH' && 'flex' }}
            className="mobile-column-switch"
          >
            <div
              style={{
                padding: 10,
                width: formValues.role?.toUpperCase() === 'OTH' ? '100%' : '50%'
              }}
              className="mobile-role-width-switch"
            >
              <FormControl fullWidth>
                <InputLabel
                  variant="outlined"
                  margin="dense"
                  error={formErrors.role}
                  htmlFor="role"
                >
                  *Identify the role that best describes you
                </InputLabel>
                <MuiSelect
                  native
                  variant={'outlined'}
                  value={formValues.role}
                  onChange={updateFormField('role')}
                  error={formErrors.role}
                  label="*Identify the Role that best describes you"
                  margin={'dense'}
                  inputProps={{
                    name: 'role',
                    id: 'role',
                    maxLength: 50
                  }}
                >
                  <option aria-label="None" key="none" value="" />
                  {_.map(
                    _.filter(dropDownValues.roles, (rl) => rl.subcatid !== 6),
                    (role) => {
                      return (
                        <option key={role.subcatid} value={role.subcatcode}>
                          {role.name}
                        </option>
                      );
                    }
                  )}
                  <option key={VERICEL_REP_ROLE} value={VERICEL_REP_ROLE}>
                    Vericel Rep / Other Employee
                  </option>
                </MuiSelect>
              </FormControl>
            </div>
            {formValues.role?.toUpperCase() === 'OTH' && (
              <TextField
                style={{ margin: 10, minWidth: '50%' }}
                value={formValues.other_role || ''}
                onChange={updateFormField('other_role')}
                label={'*Other Role'}
                error={formErrors.other_role}
                margin={'dense'}
                variant={'outlined'}
                inputProps={{ maxLength: 100 }}
              />
            )}
          </div>
        )}
        {isLicensed && (
          <div style={{ display: 'flex', marginTop: 10 }} className="mobile-column-reverse-switch">
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <FormControl style={{ marginLeft: 10, marginRight: 10, display: 'block' }}>
                <SelectMultiField
                  values={formValues.specialty}
                  label={'*Specialty'}
                  options={_.map(dropDownValues.specialties, (specialty) => ({
                    value: specialty.name,
                    label: specialty.name
                  }))}
                  onChange={updateSelectMultiple('specialty')}
                  error={formErrors.specialty}
                />
              </FormControl>
              {_.find(
                formValues.specialty || [],
                (spclty) => spclty.value.toUpperCase() === 'OTHER'
              ) && (
                <TextField
                  fullWidth
                  style={{ margin: 10, paddingRight: 20 }}
                  value={formValues.other_specialty || ''}
                  onChange={updateFormField('other_specialty')}
                  label={'*Other Specialty'}
                  error={formErrors.other_specialty}
                  margin={'dense'}
                  variant={'outlined'}
                  inputProps={{ maxLength: 50 }}
                />
              )}
              <FormHelperText style={{ marginLeft: 15 }}>
                If you cannot locate your specialty from this drop-down menu, please contact your
                local sales representative, as you may not be permitted to attend this program.{' '}
              </FormHelperText>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
              }}
            >
              <FormControl
                style={{
                  display: 'block',
                  margin: '2px 10px 5px 10px'
                }}
              >
                <SelectMultiField
                  values={formValues.degree}
                  label={'*Degree'}
                  options={_.map(dropDownValues.degrees, (degree) => ({
                    value: degree.name,
                    label: degree.name
                  }))}
                  onChange={updateSelectMultiple('degree')}
                  error={formErrors.degree}
                />
              </FormControl>
              {_.find(
                formValues.degree || [],
                (degree) => degree.value.toUpperCase() === 'OTHER'
              ) && (
                <TextField
                  fullWidth
                  style={{ margin: 10, paddingRight: 20 }}
                  value={formValues.other_degree || ''}
                  onChange={updateFormField('other_degree')}
                  label={'*Other Degree'}
                  error={formErrors.other_degree}
                  margin={'dense'}
                  variant={'outlined'}
                  inputProps={{ maxLength: 50 }}
                />
              )}
            </div>
          </div>
        )}

        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            disabled={isVericelRep}
            style={{ margin: 10 }}
            value={formValues.orgname || ''}
            onChange={updateFormField('orgname')}
            label={isLicensed || !isVericelRep ? '*Affiliation' : 'Affiliation'}
            error={formErrors.orgname}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 100 }}
          />
        </div>

        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            disabled={isVericelRep}
            style={{ margin: 10 }}
            value={formValues.address1 || ''}
            onChange={updateFormField('address1')}
            label={'*Office Address'}
            error={formErrors.address1}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 50 }}
          />
          <TextField
            fullWidth
            disabled={isVericelRep}
            style={{ margin: 10 }}
            value={formValues.address2 || ''}
            onChange={updateFormField('address2')}
            label={'Address 2'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 50 }}
          />
        </div>
        <div className="flex mobile-column-switch">
          <TextField
            disabled={isVericelRep}
            style={{ margin: 10, minWidth: '30%' }}
            value={formValues.city || ''}
            onChange={updateFormField('city')}
            label={'*City'}
            error={formErrors.city}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 50 }}
          />
          <div className="flex" style={{ minWidth: '50%' }}>
            <FormControl disabled={isVericelRep} style={{ margin: 10, flex: '1 50px' }}>
              <InputLabel
                variant="outlined"
                margin="dense"
                error={formErrors.state}
                htmlFor="state"
              >
                *State
              </InputLabel>
              <MuiSelect
                native
                variant={'outlined'}
                value={formValues.state || ''}
                onChange={updateFormField('state')}
                error={formErrors.state}
                margin={'dense'}
                label="*State"
                inputProps={{
                  name: 'state',
                  id: 'state',
                  maxLength: 2
                }}
              >
                {_.map(dropDownValues.states, (state) => {
                  return (
                    <option key={state.abrv} value={state.abrv}>
                      {state.name}
                    </option>
                  );
                })}
              </MuiSelect>
            </FormControl>
            <TextField
              fullWidth
              disabled={isVericelRep}
              style={{ margin: 10, flex: '1 100px' }}
              value={formValues.zip || ''}
              onChange={updateFormField('zip')}
              label={'*Zip'}
              error={formErrors.zip}
              margin={'dense'}
              variant={'outlined'}
              inputProps={{ minLength: 5, maxLength: 10 }}
            />
          </div>
        </div>
        {isLicensed && renderNpiFields()}
        {/* {!isLicensed && renderStateLicenseNumber()} */}
        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.home_phone || ''}
            onChange={updateFormField('home_phone')}
            label={'Office Phone'}
            error={formErrors.home_phone}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 15 }}
            type="tel"
          />
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.fax || ''}
            onChange={updateFormField('fax')}
            label={'Fax'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 15 }}
            type="tel"
          />
        </div>
        <div style={{ display: 'flex' }}>
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.phone || ''}
            error={formErrors.phone}
            onChange={updateFormField('phone')}
            label={'*Mobile Phone'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 15 }}
            type="tel"
          />
          <TextField
            fullWidth
            style={{ margin: 10 }}
            value={formValues.email || ''}
            onChange={updateFormField('email')}
            label={'*Email'}
            error={formErrors.email}
            helperText={formErrors.email && 'Invalid email address'}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{ maxLength: 100 }}
            type="email"
          />
        </div>
        <div style={{ padding: 10 }}>
          <TextField
            className="multiLineTextField"
            fullWidth
            multiline
            rows={5}
            value={formValues.dietary_constraints || ''}
            onChange={updateFormField('dietary_constraints')}
            InputLabelProps={{
              style: { fontSize: 14, paddingRight: 5 }
            }}
            label={'Dietary constraints'}
            variant={'outlined'}
            inputProps={{ maxLength: 50 }}
          />
        </div>
        <div style={{ padding: 10 }}>
          <TextField
            className="multiLineTextField"
            fullWidth
            multiline
            rows={5}
            value={formValues.comments || ''}
            InputLabelProps={{
              style: { fontSize: 14 }
            }}
            onChange={updateFormField('comments')}
            label={'Comments'}
            variant={'outlined'}
            inputProps={{ maxLength: 100 }}
          />
        </div>
        <div style={{ paddingLeft: 10 }}>
          <FormControl required error={formErrors.email_consent}>
            <FormControlLabel
              style={{ alignItems: 'flex-start' }}
              control={
                <Checkbox
                  color="default"
                  checked={formValues.email_consent}
                  onChange={updateFormField('email_consent')}
                  name="email_consent"
                  style={{ paddingTop: 2 }}
                />
              }
              label="I give my consent to use my email address for communications involving this event only"
            />
            {formErrors.email_consent && <FormHelperText>This field is required.</FormHelperText>}
          </FormControl>
        </div>
        {meetingInfo.sms_opt_in_enabled && (
          <div style={{ paddingLeft: 10, marginBottom: 10 }}>
            <FormControl required error={formErrors.sms_opt_in}>
              <FormControlLabel
                style={{ alignItems: 'flex-start' }}
                control={
                  <Checkbox
                    color="default"
                    checked={formValues.sms_opt_in}
                    onChange={updateFormField('sms_opt_in')}
                    name="sms_opt_in"
                    style={{ paddingTop: 2 }}
                  />
                }
                label="Opt in for mobile text messages about this event only (messaging rates may apply)"
              />
              {formErrors.sms_opt_in && <FormHelperText>This field is required.</FormHelperText>}
            </FormControl>
          </div>
        )}
        {meetingInfo.is_virtual_hybrid && (
          <div style={{ paddingLeft: 10, marginBottom: 20 }}>
            <FormControl required error={formErrors.attendanceType}>
              <span style={{ maxWidth: 750 }}>
                The program you are registering for is hybrid and can accomodate both in-person and
                virtual attendees. <br />
                Please confirm how you are planning to attend by choosing from the options below.
              </span>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="default"
                      checked={attendanceType === 'in-person'}
                      onChange={onVirtualHybridChange('in-person')}
                      name="is_virtual_hybrid"
                    />
                  }
                  label="In-person"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      color="default"
                      checked={attendanceType === 'virtual'}
                      onChange={onVirtualHybridChange('virtual')}
                      name="is_virtual_hybrid"
                    />
                  }
                  label="Virtual"
                />
              </FormGroup>
              {formErrors.attendanceType && (
                <FormHelperText style={{ color: '#f44336' }}>
                  This field is required.
                </FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        <div style={{ paddingLeft: 10, marginBottom: 20 }} className="MuiTypography-body1">
          <span style={{ display: 'block', marginBottom: 10 }}>
            <b>Restrictions for US HCPs:</b> In compliance with the AdvaMed Code of Ethics on
            Interactions with Healthcare Professionals, guests and/or spouses will not be permitted
            to attend. Please note that Vericel is subject to several laws that restrict the
            provision of food and beverage in connection with an event. In particular, some state
            and local jurisdictions, such as Vermont, Louisiana and Minnesota, prohibit or limit
            companies like Vericel from providing food and beverage to HCPs. Please disclose if you
            are licensed in a state or work in a jurisdiction or facility that limits or prohibits
            HCPs from partaking in a meal or refreshments. Any HCPs with meal/refreshment
            prohibitions are required to opt-out as noted on the sign-in form. Vericel is also
            subject to other federal disclosure laws. Vericel will report the name and value
            received for all HCPs who receive a meal as required by law. So that we may comply with
            federal and state disclosure laws, Vericel Corporation requires all practitioners in
            attendance to sign in. On the sign-in sheet, you have the option to indicate your
            non-participation in the meal offered in connection with this program. If selected,
            Vericel Corporation will not report a transfer of value to you.
            <br />
            <b>Restrictions for International HCPs:</b> HCPs from outside of the US may not attend
            this promotional program about US FDA-approved products.
          </span>
          <span style={{ display: 'block' }}>
            The information you provide will be used in accordance with Vericel's{' '}
            <a
              href="https://www.vcel.com/privacy-policy/"
              target="_blank"
              style={{ color: 'black' }}
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>{' '}
            and{' '}
            <a
              href="https://www.vcel.com/terms-and-conditions-of-use/"
              target="_blank"
              style={{ color: 'black' }}
              rel="noopener noreferrer"
            >
              Terms and Conditions of Use
            </a>
            .
          </span>
        </div>
      </div>
      {submitError && (
        <p style={{ color: 'red', textAlign: 'center', fontSize: 20 }}>{submitError}</p>
      )}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          style={{ width: 125 }}
          className="hlx-button"
          variant="contained"
          onClick={() => submitForm()}
        >
          Register
        </Button>
        <Button
          style={{ width: 125 }}
          className="cancel-btn hlx-button"
          variant="contained"
          onClick={() => setData({ npiInfo: null, isLicensed: null })}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = ({ data }) => {
  const { dropDownValues, isLicensed, npiInfo, meetingInfo, regSource } = data;
  return { dropDownValues, isLicensed, npiInfo, meetingInfo, regSource };
};
export default connect(mapStateToProps, { setData: setDataAction })(VericelRegFormComponent);
